import * as $ajax from './_ajax'
import * as $msg from './_msg'
import * as $resources from './_resources'
import * as $types from './_types'

export interface IInitOptions {
    pageName: string;
    pagePrefix: string;
}

var options:IInitOptions;

export function init($options: IInitOptions): void {
    options = $.extend(true, {}, $options);

    $("." + options.pagePrefix + "-delete").click(function () {
        deleteCode($(this).attr("data-id"));
    });

    $("." + options.pagePrefix + "-expand-icon").click(function () {
        toggleExpand($(this));
    });
}

function toggleExpand(icon: JQuery): void {
    var id: string = icon.attr("data-id");
    var tr: JQuery = $("." + options.pagePrefix + "-expanded-" + id);

    if (icon.hasClass("fa-chevron-right")) {
        icon.removeClass("fa-chevron-right");
        icon.addClass("fa-chevron-down");
        tr.removeClass("bcfla-hidden");
    } else {
        icon.addClass("fa-chevron-right");
        icon.removeClass("fa-chevron-down");
        tr.addClass("bcfla-hidden");
    }
}

function deleteCode(id:string) : void {
    if (!confirm("Är du säker på att du vill inaktivera denna enhet?")) return;

    $ajax.post({
        loadingText: "Raderar...",
        url: $resources.url.account.deleteCode,
        data: {
            guid: elem("guid").val(),
            id: id
        },
        success: function (res: $types.object.IJsonResult) {
            if (res.Ok) {
                hamtaKodLista();
            } else {
                $msg.showError(res.Message);
            }
        }
    });
}

function hamtaKodLista() {
    $ajax.post({
        loadingText: "Hämtar lista...",
        url: $resources.url.account.myPageCodes,
        data: {
            guid: elem("guid").val()
        },
        dataType: "html",
        success: function (res) {
            $("." + options.pageName).parent().html(res);
        }
    });
}

function elem(id:string) : JQuery {
    return $("#" + options.pagePrefix + "-" + id);
}